import Vue from 'vue';
import * as filter from 'src/util/filter';

for (const [name, filterFn] of Object.entries(filter)) {
	Vue.filter(name, filterFn);
}
